module.exports = __webpack_public_path__ + "img/plPer.6c46376a.svg";